<template>
  <div class="cuscd-hero-wrap">
    <div class="cuscd-overlay"></div>
    <img
      :src="backgroundImage"
      :alt="backgroundImageAltText"
      class="cuscd-img-banner"
      :class="backgroundImageClass"
    />
    <div class="cuscd-banner-text">
      <p class="cuscd-small-title">Welcome to the SLC Applicant Portal</p>
      <p class="cuscd-h1style" v-if="oidcIsAuthenticated">
        {{ decodeHTMLEncodedStr(formatName(oidcUser.nickname?.toLowerCase())) }}
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { ImageConstants } from "@/config/constants";
import { defineComponent, computed } from "vue";
import { mapGetters, useStore } from "vuex";
import useHtmlUtilities from "@/use/htmlUtilities";
import useFormatter from "@/use/formatter";

export default defineComponent({
  props: [],
  name: "Hero",
  setup() {
    const store = useStore();
    const { decodeHTMLEncodedStr } = useHtmlUtilities();
    const { formatName } = useFormatter();
    const backgroundImage = computed(() => store.getters["backgroundImageUrl"]);
    const backgroundImageAltText = computed(() => store.getters["backgroundImageAltText"]);
    const backgroundImageClass = computed(() => store.getters["refiClassName"]);

    return {
      decodeHTMLEncodedStr,
      formatName,
      backgroundImage,
      backgroundImageAltText,
      backgroundImageClass,
    };
  },
  computed: {
    ...mapGetters("oidcStore", ["oidcIsAuthenticated", "oidcUser"]),
  },
});
</script>

<style scoped>
.cuscd-hero-wrap {
  display: block;
  height: 100%;
  top: 0;
  left: 0;
  margin: 0 auto;
  max-width: 1640px;
  position: absolute;
  right: 0;
  width: 100%;
}

.cuscd-full-wrap .cuscd-img-banner {
  bottom: 0;
  display: block;
  max-height: 27rem;
  max-width: 33%;
  position: absolute;
  right: 0.9375rem;
  width: auto;
  top: calc(100% - 303px);
}

.cuscd-overlay {
  position: relative;
}

@media (max-width: 992px) {
  .cuscd-hero-wrap {
    border-color: #080808;
    color: #fff;
    height: 15rem;
    position: relative;
    text-align: center;
  }
  .cuscd-full-wrap .cuscd-img-banner {
    max-height: 75%;
    max-width: 100%;
    right: 0;
    top: 60px;
  }

  .cuscd-hero-wrap .cuscd-overlay {
    bottom: 0;
    background: -moz-linear-gradient(-45deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0) 100%);
    background: -webkit-linear-gradient(-45deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0) 100%);
    background: linear-gradient(135deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#1a000000', endColorstr='#00000000',GradientType=1 );
    background-color: var(--theme-color);
    cursor: pointer;
    display: inline-block;
    height: auto;
    left: 0;
    mix-blend-mode: multiply;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
    z-index: 2;
  }
  .cuscd-dark .cuscd-hero-wrap .cuscd-overlay {
    background: -moz-linear-gradient(
      -45deg,
      rgba(255, 255, 255, 0.2) 0%,
      rgba(255, 255, 255, 0) 100%
    );
    background: -webkit-linear-gradient(
      -45deg,
      rgba(255, 255, 255, 0.2) 0%,
      rgba(255, 255, 255, 0) 100%
    );
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#33ffffff',GradientType=1 );
    background-color: var(--theme-color);
  }
  .cuscd-hero-wrap img {
    width: 100%;
  }
  .cuscd-hero-wrap .cuscd-banner-text {
    display: block;
    left: 0;
    margin: 0 auto;
    max-width: 20.2rem;
    padding: 2.7rem 0 0 0;
    position: absolute;
    right: 0;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    top: 50%;
    width: 100%;
    z-index: 3;
  }

  .cuscd-banner-text .cuscd-small-title,
  .cuscd-banner-text .cuscd-h1style {
    text-align: center;
  }
  .cuscd-banner-text .cuscd-small-title {
    color: #ffffff;
    display: block;
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 1.33em;
    margin: 0 auto;
    max-width: 10.8em;
    padding: 0 0 0.16em 0;
    width: 100%;
  }
  .cuscd-banner-text .cuscd-h1style {
    font-size: 2.1875rem;
    font-weight: 600;
    line-height: 1em;
    margin: 0 auto;
  }

  .cuscd-dark .cuscd-banner-text .cuscd-small-title,
  .cuscd-dark .cuscd-banner-text .cuscd-h1style {
    color: #000100;
  }
}

@media (max-width: 600px) {
  .cuscd-hero-wrap .cuscd-banner-text {
    max-width: 15.188rem;
    top: 54%;
  }
  .cuscd-full-wrap .cuscd-img-banner.refi {
    display: none;
  }
}

@media (max-width: 413px) {
  .cuscd-hero-wrap img {
    width: 116%;
  }
  .cuscd-banner-text .cuscd-small-title {
    font-size: 0.75rem;
    line-height: 1rem;
    max-width: 9.05rem;
    padding-bottom: 0.6rem;
  }
  .cuscd-banner-text .cuscd-h1style {
    font-size: 2.188rem;
  }
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .cuscd-hero-wrap .cuscd-overlay {
    opacity: 0.8;
  }
}
</style>
